import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useBootstrapStatus(): {
  loading: boolean;
  initialized: boolean | null;
  error: string | null;
  refetch: () => void;
} {
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .bootstrapStatus()
      .then((res) => {
        if (cancelled) return;
        setInitialized(res.initialized);
      })
      .catch((e: Error) => {
        if (cancelled) return;
        setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return { loading, initialized, error, refetch: () => setTick((n) => n + 1) };
}
